
import { Injectable, EventEmitter } from '@angular/core';
import { LocalStorageService } from '../services/local-storage.service';
import { FormElements } from '../models/FormElements';

@Injectable({
    providedIn: 'root'
})
export class VentanaUtils {

    constructor(private localstorage: LocalStorageService) {

        window.addEventListener('resize', function () {
            // umbral de responsividad = 450
            var windowStatus = localstorage.getWindowStatus();

            // widthSize con largo por defecto (cuando se muestra el icono de asistencia)
            var widthSize = '120px';
            // Si la ventana esta maximizada o minimizada
            if (windowStatus === 'max' || windowStatus === 'min') {
                widthSize = (window.screen.width < 450) ? '340px' : '450px';
            }

            if (window.parent.document.getElementById('iframe_aliss')) {
                window.parent.document.getElementById('iframe_aliss').style.width = widthSize;
                window.parent.document.getElementById('iframe_aliss').style.minWidth = widthSize;
            }
        });
    }

    close: EventEmitter<any> = new EventEmitter<any>();

    bannerStyleDefault = null;

    public renderDiv(name, val) {
        if (val) {
            window.document.getElementById(name).style.display = 'block';
        } else {
            window.document.getElementById(name).style.display = 'none';
        }
    }

    public minimizarVentana() {

        this.renderDiv('divContent', false);
        if (window.document.getElementsByClassName('banner')) {
            let hayError = false;
            try {
                window.document.getElementById('bannerId').style.bottom = '0';
                window.document.getElementById('bannerId').style.position = 'absolute';
                window.document.getElementById('bannerId').style.height = '50px';
                window.document.getElementById('bannerId').style.borderBottom = '0px 0px 0px 0px';
            } catch (error) {
                hayError = true;
                console.log(error);
            }
            try {
                window.parent.document.getElementById('bannerId').style.borderColor = 'white';
                window.parent.document.getElementById('bannerId').style.borderStyle = 'solid none none solid;';
                window.parent.document.getElementById('bannerId').style.borderRadius = '0px';
                window.parent.document.getElementById('bannerId').style.borderWidth = '1px';
            } catch (error) {
                hayError = true;
                console.log(error);
            }
            if (hayError) {
                try {
                    window.document.getElementById('bannerId').style.borderColor = 'white';
                    window.document.getElementById('bannerId').style.borderStyle = 'solid none none solid;';
                    window.document.getElementById('bannerId').style.borderRadius = '0px';
                    window.document.getElementById('bannerId').style.borderWidth = '1px';
                } catch (error) {
                    console.log(error);
                }
            }

            // La combinacion de atributos 'right' y 'width' (4px y 98%) genera la sombra 
            // necesarias para el contraste con el footer azul del portal             
            window.document.getElementById('bannerId').style.right = '4px';
            window.document.getElementById('bannerId').style.width = '98%';

        }

        this.minimizarIframe();
    }

    public maximizarVentana(isChat: boolean) {

        this.renderDiv('divContent', true);
        if (window.document.getElementsByClassName('banner')) {
            let hayError = false;
            try {
                window.document.getElementById('bannerId').style.height = '67px';
                window.document.getElementById('bannerId').style.position = 'static';
                window.document.getElementById('bannerId').style.borderBottom = '3px solid #ccc';
            } catch (error) {
                hayError = true;
                console.log(error);
            }
            try {
                window.parent.document.getElementById('bannerId').style.borderColor = '';
                window.parent.document.getElementById('bannerId').style.borderStyle = '';
                window.parent.document.getElementById('bannerId').style.borderRadius = '';
                window.parent.document.getElementById('bannerId').style.borderWidth = '';
                window.parent.document.getElementById('bannerId').style.boxShadow = '';
            } catch (error) {
                hayError = true;
                console.log(error);
            }
            if (hayError) {
                try {
                    window.document.getElementById('bannerId').style.borderColor = '';
                    window.document.getElementById('bannerId').style.borderStyle = '';
                    window.document.getElementById('bannerId').style.borderRadius = '';
                    window.document.getElementById('bannerId').style.borderWidth = '';
                    window.document.getElementById('bannerId').style.boxShadow = '';
                } catch (error) {
                    console.log(error);
                }
            }

            // La combinacion de atributos 'right' y 'width' (0px y 100%) restaura la alteracion provacada en 'minimizarVentana'            
            window.document.getElementById('bannerId').style.right = '0px';
            window.document.getElementById('bannerId').style.width = '100%';
        }

        this.maximizarIframe(isChat);
    }

    minimizarIframe() {
        if (window.parent.document.getElementById('iframe_aliss')) {
            let hayError = false;
            // Al minimizar ventana tambien minimizo iframe contenedor (370 x 60) o (340 x 60 si es mobile)
            window.parent.document.getElementById('iframe_aliss').style.height = '60px';
            // umbral de responsividad = 450
            var widthSize = (window.screen.width < 450) ? '340px' : '370px';
            try {
                window.parent.document.getElementById('iframe_aliss').style.width = widthSize;
                window.parent.document.getElementById('iframe_aliss').style.minHeight = '60px';
                window.parent.document.getElementById('iframe_aliss').style.minWidth = widthSize;
                window.parent.document.getElementById('iframe_aliss').style.bottom = '0px';
            } catch (error) {
                hayError = true;
                console.log(error);
            }
            if (hayError) {
                try {
                    window.document.getElementById('iframe_aliss').style.width = widthSize;
                    window.document.getElementById('iframe_aliss').style.minHeight = '60px';
                    window.document.getElementById('iframe_aliss').style.minWidth = widthSize;
                    window.document.getElementById('iframe_aliss').style.bottom = '0px';
                } catch (error) {
                    hayError = true;
                    console.log(error);
                }
            }

            hayError = false;
            try {
                window.parent.document.getElementById('bannerId').style.boxShadow = '2px 2px 10px rgb(255 255 255 / 100%)';
                window.parent.document.getElementById('bannerId').style.borderColor = 'white';
                window.parent.document.getElementById('bannerId').style.borderStyle = 'solid none none solid;';
                window.parent.document.getElementById('bannerId').style.borderRadius = '0px';
                window.parent.document.getElementById('bannerId').style.borderWidth = '1px';
            } catch (error) {
                hayError = true;
                console.log(error);
            }

            if (hayError) {
                try {
                    window.document.getElementById('bannerId').style.boxShadow = '2px 2px 10px rgb(255 255 255 / 100%)';
                    window.document.getElementById('bannerId').style.borderColor = 'white';
                    window.document.getElementById('bannerId').style.borderStyle = 'solid none none solid;';
                    window.document.getElementById('bannerId').style.borderRadius = '0px';
                    window.document.getElementById('bannerId').style.borderWidth = '1px';
                } catch (error) {
                    hayError = true;
                    console.log(error);
                }
            }

        }
    }

    maximizarIframe(isChat: boolean) {
        if (window.parent.document.getElementById('iframe_aliss')) {
            if (isChat) {
                // al maximizar restauro el iframe con los valores originales
                this.chatComponentStyle();
            } else {
                this.emailComponentStyle();
            }
        }
    }

    public setDefaultIframeSize() {
        // Risize del Iframe usado cuando se despliega el incono de asistencia
        if (window.parent.document.getElementById('iframe_aliss')) {
            window.parent.document.getElementById('iframe_aliss').style.height = '120px';
            window.parent.document.getElementById('iframe_aliss').style.minHeight = '120px';
            window.parent.document.getElementById('iframe_aliss').style.width = '120px';
            window.parent.document.getElementById('iframe_aliss').style.minWidth = '120px';
            window.parent.document.getElementById('iframe_aliss').style.bottom = '100px';
        }
    }

    public styleNewMessage() {
        window.document.getElementById('bannerId').style.backgroundColor = '#3ea22f';
        window.document.getElementById('bannerId').classList.add("transition");
    }

    public resetStyleNewMessage() {
        window.document.getElementById('bannerId').style.backgroundColor = '#013b82';
        window.document.getElementById('bannerId').classList.remove("transition");
    }

    public chatComponentStyle() {
        if (window.parent.document.getElementById('iframe_aliss')) {
            window.parent.document.getElementById('iframe_aliss').style.height = '90%';
            window.parent.document.getElementById('iframe_aliss').style.width = '450px';
            window.parent.document.getElementById('iframe_aliss').style.minHeight = '90%';
            window.parent.document.getElementById('iframe_aliss').style.minWidth = '370px';
            window.parent.document.getElementById('iframe_aliss').style.bottom = '0px';
        }
        /*
          Se usa windows.parent.document.getElementById porque 
          no esta andando  window.frameElement.style.height =xxx
        */
    }

    public emailComponentStyle() {
        // Tiene los mismos valores de la ventana de chat.
        // TODO: hay que cambiar el nombre iframe_aliss por iframe_aliss (neutro)
        if (window.parent.document.getElementById('iframe_aliss')) {
            window.parent.document.getElementById('iframe_aliss').style.height = '90%';
            window.parent.document.getElementById('iframe_aliss').style.width = '450px';
            window.parent.document.getElementById('iframe_aliss').style.minHeight = '90%';
            window.parent.document.getElementById('iframe_aliss').style.minWidth = '370px';
            window.parent.document.getElementById('iframe_aliss').style.bottom = '0px';
        }
        /*
          Se usa windows.parent.document.getElementById porque 
          no esta andando  window.frameElement.style.height =xxx
        */
    }

    public menuArbolComponentStyle() {
        if (window.parent.document.getElementById('iframe_aliss')) {
            window.parent.document.getElementById('iframe_aliss').style.height = '90%';
            window.parent.document.getElementById('iframe_aliss').style.width = '450px';
            window.parent.document.getElementById('iframe_aliss').style.minHeight = '90%';
            window.parent.document.getElementById('iframe_aliss').style.minWidth = '370px';
            window.parent.document.getElementById('iframe_aliss').style.bottom = '0px';
        }
        /*
          Se usa windows.parent.document.getElementById porque 
          no esta andando  window.frameElement.style.height =xxx
        */
    }

    public navigateTo(url: string) {
        window.parent.location.href = url;
    }

    public getBaseUrl(): string {
        return window.parent.location.href;
    }
}
